<template>
  <div
    style="background: #ffffff;"
    class="border">
    <weex-text class="emi-scheme-name border-bottom">{{getValue('emiSchemeName')}}</weex-text>

    <div class="emi-scheme-item">
      <weex-text class="emi-scheme-item-label"># of EMIs</weex-text>
      <weex-text class="item-align-right emi-scheme-item-value">{{getValue('noOfEmi')+' Months'}}
      </weex-text>
    </div>

    <div
      class="emi-scheme-item"
      v-if="showDownPaymentAmount">
      <weex-text class="emi-scheme-item-label">Down Payment</weex-text>
      <weex-text class="item-align-right emi-scheme-item-value">{{getAmount('downpaymentAmount')}}
      </weex-text>
    </div>

    <div
      class="emi-scheme-item"
      v-if="showMarginMoney">
      <weex-text class="emi-scheme-item-label">Margin Money</weex-text>
      <weex-text class="item-align-right emi-scheme-item-value">{{getAmount('marginMoney')}}
      </weex-text>
    </div>

    <div class="emi-scheme-item">
      <weex-text class="emi-scheme-item-label">EMI Amount</weex-text>
      <weex-text class="item-align-right emi-scheme-item-value">{{getAmount('emi')}}</weex-text>
    </div>

    <div
      class="emi-scheme-item"
      v-if="getAmount('processingFee')">
      <div>
        <weex-text class="emi-scheme-item-label">Processing Fee</weex-text>
        <weex-text class="emi-scheme-item-label-small">[Inclusive of GST]</weex-text>
      </div>
      <weex-text class="item-align-right emi-scheme-item-value">{{getAmount('processingFee')}}
      </weex-text>
    </div>

    <div
      class="emi-scheme-item"
      v-if="false">
      <weex-text class="emi-scheme-item-label">Total Cost</weex-text>
      <weex-text class="item-align-right emi-scheme-item-value">{{getAmount('amount')}}</weex-text>
    </div>

    <wxc-button
      text="Choose"
      class="horizontal_center margin-top-5 margin-bottom-5"
      size="medium"
      type="blue"
      @wxcButtonClicked="onEmiSchemeChosen()">
    </wxc-button>
  </div>

</template>

<script>
  import WxcButton from "@/../weex-ui/packages/wxc-button/index"
  import { Constants } from "@/components/Constants";

  export default {
    name: "EmiSchemeItem",
    components: { WxcButton },
    props: {
      emiScheme: {
        type: Object,
        required: true,
        default: {}
      }
    },
    methods: {
      onEmiSchemeChosen() {
        this.$emit('onEmiSchemeChosen', this.emiScheme);
      },

      getValue(key) {
        if (this.emiScheme && this.emiScheme[key]) {
          return this.emiScheme[key];
        }
        return '';
      },

      getAmount(key) {
        if (this.emiScheme && this.emiScheme[key]) {
          return Constants.RUPEE + this.emiScheme[key].toFixed(0);
        }

        return '';
      }
    },

    computed: {
      showMarginMoney() {
        return this.emiScheme && this.emiScheme['marginMoney'] && this.emiScheme['marginMoney'] > 0;
      },

      showDownPaymentAmount() {
        return this.emiScheme && this.emiScheme['downPayment'] && this.emiScheme['downPayment'] > 0;
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>

  .emi-scheme-name {
    text-align: center;
    font-size: 16px;
    color: #196B17;
    margin-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .emi-scheme-item {
    margin: 10px;
    flex-direction: row;
    padding-bottom: 10px;
    border-bottom-width: 1px;
    border-bottom-color: #F6F6F6;
    display: flex;
  }

  .emi-scheme-item-label {
    font-size: 16px;
    color: #1866C2;
  }

  .emi-scheme-item-label-small {
    font-size: 12px;
    color: #1866C2;
  }

  .emi-scheme-item-value {
    color: #4E4E4E;
    font-size: 16px;
  }

</style>
